import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const upsertForceReducer = (
    state: ForceState,
    { force }: ReturnType<typeof FORCE_ACTIONS.UPSERT_FORCE | typeof FORCE_ACTIONS.UPSERT_FORCE_WITHOUT_UPLOAD>
) => {
    const forces = state.forces.map((f) => {
        if (force.id !== f.id) {
            return f;
        }

        // Preserve the newer updatedAt timestamp to prevent sync conflicts.
        // This handles the case where application code calls upsert with a force
        // that has a stale timestamp (e.g., captured before a recent upload completed).
        const updatedAt = Math.max(f.updatedAt || 0, force.updatedAt || 0) || undefined;

        return {
            ...force,
            updatedAt
        };
    });

    if (!forces.find((f) => f.id === force.id)) {
        forces.push(force);
    }

    return {
        ...state,
        forces
    };
};
